import { merge } from 'lodash';

export const findRoute = (routes, paths) => {
  const [path] = paths;
  const route = routes.find(route => route.path === path);
  if (paths.length > 1) {
    if (route && route.children) {
      return findRoute(route.children, paths.slice(1));
    }
  }
  return route;
};
export const setRoute = (route, value) => {
  if (typeof value === 'string') {
    route.path = value;
    return;
  }
  merge(route, value);
};

export const overrideRoute = (routes, override) => {
  Object.keys(override).forEach(key => {
    const paths = key.split('.');
    const route = findRoute(routes, paths);
    if (route) {
      setRoute(route, override[key]);
    }
  });
  return routes;
};
